export const withoutUmlauts = (string: string) => {
  return string
    .replaceAll("ü", "ue")
    .replaceAll("ä", "ae")
    .replaceAll("ö", "oe")
    .replaceAll("Ä", "Ae")
    .replaceAll("Ü", "Ue")
    .replaceAll("Ö", "Oe");
};
